import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppDownload"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\sections\\app-download.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CtaSection"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\sections\\cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Developer"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\sections\\developer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Features"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\sections\\features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\sections\\hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorks"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\sections\\how-it-works.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Stats"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\sections\\stats.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WorldMap"] */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\components\\sections\\world-map.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\Users\\HP\\Desktop\\rombex_web\\rombex-homepage-design-main\\node_modules\\next\\dist\\client\\image-component.js");
